module.exports = __webpack_public_path__ + "static/media/ytheatre_2.e82a206c.jpg";